import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getParticipants,
  addParticipants,
  updateParticipant as updateParticipantApi,
  exportParticipants,
  downloadReceipt
} from "../../api/admin/tournaments.api";

/* ============================================================
   🔥 RESPONSE NORMALIZER (VERY IMPORTANT)
   Handles:
   1. { data: [...] }
   2. { data: { data: [...] } }
============================================================ */
const normalizeResponse = (res) => {
  let data = [];

  if (Array.isArray(res?.data)) {
    data = res.data;
  } else if (Array.isArray(res?.data?.data)) {
    data = res.data.data;
  }

  return {
    data,
    meta: res?.meta || {
      total: data.length,
      total_pages: 1,
      page: 1,
      limit: 10,
    },
  };
};

/* ================= FETCH ================= */
export const fetchParticipants = createAsyncThunk(
  "admin/tournamentParticipants/fetch",
  async (
    { tournament_id, page = 1, limit = 10, search = "" },
    { rejectWithValue }
  ) => {
    try {
      const res = await getParticipants({
        tournament_id,
        page,
        limit,
        search,
      });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      const normalized = normalizeResponse(res);

      console.log("🔥 NORMALIZED DATA:", normalized);

      return normalized;

    } catch (error) {
      return rejectWithValue(error.message || "Fetch failed");
    }
  }
);

/* ================= ADD ================= */
export const addParticipant = createAsyncThunk(
  "admin/tournamentParticipants/add",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await addParticipants(payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;

    } catch (error) {
      return rejectWithValue(error.message || "Add failed");
    }
  }
);

/* ================= UPDATE ================= */
export const updateParticipant = createAsyncThunk(
  "admin/tournamentParticipants/update",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await updateParticipantApi(payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return {
        data: payload, // ✅ UI update instantly
      };

    } catch (error) {
      return rejectWithValue(error.message || "Update failed");
    }
  }
);

/* ================= EXPORT ================= */


export const exportParticipantsThunk = createAsyncThunk(
  "admin/tournamentParticipants/export",
  async ({ tournament_id }, { rejectWithValue }) => {
    try {
      if (!tournament_id) {
        return rejectWithValue("Tournament ID is required");
      }

      const res = await exportParticipants({ tournament_id });

      if (!res?.success) {
        return rejectWithValue(
          res?.message || "Export failed"
        );
      }

      // ⚠️ return blob (DO NOT store in Redux state)
      return res.data;

    } catch (error) {
      return rejectWithValue(
        error?.message || "Unexpected error occurred"
      );
    }
  }
);

export const downloadReceiptThunk = createAsyncThunk(
  "admin/tournamentParticipants/receipt",
  async ({ participant_id }, { rejectWithValue }) => {
    try {
      const res = await downloadReceipt({ participant_id });

      if (!res?.success) {
        return rejectWithValue(res.message);
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);